import React, { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import CustomCheckbox from "./CustomCheckbox";
import { getTextColor } from "../../../Helpers/HelperFunctions";

function FilterTags(props) {
    const {
        filterTagList,
        selectedFilterTagID,
        setSelectedFilterTagID,
        setPage,
        defaultCategories,
        getClListForSearch,
        searchInput,
        isNarrative,
        component,
        categoryId
    } = props;

    const scrollTopRef = useRef(0);

    function CustomPaper({ children }) {
        return (
            <Paper
                sx={{
                    "& .MuiAutocomplete-listbox": {
                        "& .MuiAutocomplete-option[aria-selected='true']": {
                            bgcolor: "white",
                            "&.Mui-focused": { bgcolor: "white" },
                        },
                    },
                    "& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused": {
                        bgcolor: "white",
                    },
                    border: "1px solid #D5D5D5",
                    borderRadius: "4px",
                }}
            >
                {children}
            </Paper>
        );
    }

    const handleChange = (e, value) => {
        setPage?.(0);
        const selectedIds = value?.map((item) => item?.id)?.filter(Boolean) || [];
        setSelectedFilterTagID(selectedIds);
        if (component !== "global_lists") {
            isNarrative ? getClListForSearch?.({ page: 1, page_count: 10, tags: selectedIds }) : getClListForSearch?.(1, selectedIds);
        }
    };

    useEffect(() => {
        const defaultSelected =
            defaultCategories &&
            filterTagList?.filter((item) =>
                defaultCategories?.some((tag) => tag?.name === item?.name)
            );
        if (defaultSelected?.length > 0 && selectedFilterTagID?.length === 0) {
            handleChange(null, defaultSelected);
        }
    }, [filterTagList, defaultCategories, categoryId]);

    return (
        <Autocomplete
            multiple
            size="small"
            options={filterTagList || []}
            value={
                filterTagList?.filter((tag) => selectedFilterTagID?.includes(tag.id)) ||
                []
            }
            id="multiple-limit-tags"
            PaperComponent={CustomPaper}
            className="filter-tags-textfield"
            disableCloseOnSelect
            autoHighlight={false}
            componentsProps={{ popper: { sx: { zIndex: 100000 } } }}
            ListboxProps={{
                style: { maxHeight: 300, overflow: "auto" },
                ref: (el) => {
                    if (el) {
                        el.scrollTop = scrollTopRef.current;
                    }
                },
                onScroll: (event) => {
                    scrollTopRef.current = event.target.scrollTop;
                },
            }}
            onChange={handleChange}
            getOptionLabel={(option) => option.name}
            sx={{ ml: "8px", "& .MuiOutlinedInput-root": { flexWrap: "wrap", height: 37, alignItems: "center" } }}
            renderTags={(value, getTagProps) => {
                const visible = value.slice(0, 1);
                const hiddenCount = value.length - visible.length;
                return (
                    <>
                        {visible.map((option, index) => (
                            <Chip
                                key={option.id}
                                size="small"
                                deleteIcon={<CloseIcon sx={{ color: `${getTextColor(option.color)} !important`, fontSize: 16 }} />}
                                style={{
                                    borderRadius: "35px",
                                    border: "1px solid #CED2DA",
                                    backgroundColor: option.color,
                                    color: getTextColor(option.color),
                                    maxWidth: 120,
                                    paddingLeft: "10px"
                                }}
                                label={option.name || option.title}
                                {...getTagProps({ index })}
                            />
                        ))}
                        {hiddenCount > 0 && (
                            <Typography sx={{ ml: 0.5 }}>{`+${hiddenCount}`}</Typography>
                        )}
                    </>
                );
            }}
            renderOption={(props, option, { selected }) => {
                return (
                    <li {...props} key={option?.id}>
                        <Box display={"flex"} gap={"8px"} alignItems="center">
                            <CustomCheckbox checked={selected} />
                            <Box
                                sx={{
                                    width: "12px",
                                    height: "12px",
                                    backgroundColor: option?.color,
                                    borderRadius: "50%",
                                    flexShrink: 0,
                                }}
                            />
                            <Typography
                                color={"text.primary"}
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    wordBreak: "break-word",
                                }}
                            >
                                {option.name}
                            </Typography>
                        </Box>
                    </li>
                );
            }}
            renderInput={(params) => (
                <TextField
                    size="small"
                    {...params}
                    placeholder={selectedFilterTagID?.length > 0 ? "" : "Filter by tags"}
                    sx={{
                        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#ccc" },
                        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ccc" },
                    }}
                />
            )}
        />
    );
}

export default FilterTags;